const ActionType = (actionType) => `VOD_GUIDE_${actionType}`;

export const SHOW_ITEM_DETAIL = ActionType('SHOW_ITEM_DETAIL');
export const HIDE_ITEM_DETAIL = ActionType('HIDE_ITEM_DETAIL');
export const PLAY_ITEM = ActionType('PLAY_ITEM');
export const VOD_EPISODE_WATCH = ActionType('VOD_EPISODE_WATCH');
export const CHANGE_SELECTED_GENRE = ActionType('CHANGE_SELECTED_GENRE');
export const CHANGE_SELECTED_INDEX = ActionType('CHANGE_SELECTED_INDEX');
